import { useEffect } from "react";
import { Toaster, toast } from "sonner";
import type { FeedbackMessage } from "../lib/feedback.ts";

/** Sonner renders every transient notification published by the app. */
export function GlobalFeedback() {
  useEffect(() => {
    const listener = (event: Event) => {
      const message = (event as CustomEvent<FeedbackMessage>).detail;
      const options = {
        description: message.description,
        duration: message.duration ?? 4_500,
        action: message.action
          ? {
              label: message.action.label,
              onClick: () => void message.action?.onClick(),
            }
          : undefined,
      };

      switch (message.type ?? "info") {
        case "success":
          toast.success(message.title, options);
          break;
        case "warning":
          toast.warning(message.title, options);
          break;
        case "error":
          toast.error(message.title, options);
          break;
        default:
          toast.info(message.title, options);
      }
    };

    window.addEventListener("ronda:feedback", listener);
    return () => window.removeEventListener("ronda:feedback", listener);
  }, []);

  return (
    <Toaster
      closeButton
      richColors
      position="bottom-right"
      toastOptions={{
        classNames: {
          toast: "font-sans",
          title: "font-semibold",
          description: "text-muted-foreground",
        },
      }}
    />
  );
}
